import React from "react";
import { string, oneOf } from "prop-types";

import "./event-info.m.css";

const EventInfo = ({ children, variant = "info", ...props }) => {
  const styleClass = variant === "label" ? "event-label" : variant === "title" ? "event-title" : "event-info";
  
  return (
    <div styleName={styleClass} {...props}>
      {children}
    </div>
  );
};

EventInfo.propTypes = {
  children: string.isRequired,
  variant: oneOf(["info", "label", "title"])
};

export default EventInfo;